import { memo } from "react";

export const CasinoSkeleton = memo(() => {
  return (
    <div className="flex min-h-[164px] md:min-h-[224px] justify-center items-center gap-4" role="status" aria-label="Cargando juegos de casino">
      {Array.from({ length: 3 }, (_, index) => {
        return (
          <div key={`skeleton-${index}`} className="flex flex-col items-center">
            <div className="w-[140px] h-[140px] md:w-[200px] md:h-[200px] bg-default-100 rounded-lg animate-fade mb-2" />
            <div className="w-20 h-3 bg-default-100 rounded animate-fade mb-1" />
            <div className="w-16 h-3 bg-default-100 rounded animate-fade" />
          </div>
        );
      })}
    </div>
  );
});
